const cards = [
  {
    title: '51cg平台全方位解析',
    desc: '从零开始了解51cg是什么、51cg.fun是什么，涵盖平台背景、核心功能与内容特色，帮助新用户快速建立全面认知。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20information%20platform%20concept%20with%20abstract%20data%20visualization%2C%20warm%20golden%20light%20accents%20on%20cream%20background%2C%20minimalist%20geometric%20shapes%2C%20clean%20editorial%20design%2C%20soft%20gradient%2C%20no%20text%20or%20labels%2C%20professional%20tech%20aesthetic&width=800&height=500&seq=card-01-51cg&orientation=landscape',
    tag: '入门指南',
  },
  {
    title: '域名变更应对策略',
    desc: '了解51cg域名变更的常见原因与规律，掌握快速获取最新可用网址的方法，避免因域名变动而中断访问。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20network%20of%20interconnected%20nodes%20and%20links%20representing%20domain%20routing%2C%20warm%20coral%20and%20gold%20highlights%2C%20light%20cream%20background%2C%20minimalist%20clean%20design%2C%20soft%20ambient%20lighting%2C%20no%20text&width=800&height=500&seq=card-02-51cg&orientation=landscape',
    tag: '域名导航',
  },
  {
    title: '安全访问注意事项',
    desc: '学会识别仿冒51cg的钓鱼站点，了解安全访问的几大原则，确保个人信息和浏览数据的安全不受威胁。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20shield%20and%20security%20concept%20visual%20with%20geometric%20patterns%2C%20warm%20amber%20and%20sage%20green%20accents%2C%20cream%20background%2C%20minimalist%20clean%20style%2C%20soft%20ambient%20light%2C%20no%20text%20or%20labels&width=800&height=500&seq=card-03-51cg&orientation=landscape',
    tag: '安全指南',
  },
  {
    title: '平台功能模块详解',
    desc: '逐一介绍51cg平台各主要功能模块的用途与操作方式，包括内容浏览、社区互动、个人设置等核心区域。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20dashboard%20concept%20with%20organized%20content%20blocks%20and%20modular%20design%20elements%2C%20warm%20golden%20touches%2C%20cream%20background%2C%20minimalist%20editorial%20style%2C%20soft%20lighting%2C%20no%20text&width=800&height=500&seq=card-04-51cg&orientation=landscape',
    tag: '功能教程',
  },
  {
    title: '社区生态与互动指南',
    desc: '深入了解51cg社区文化、互动规则与内容创作生态，帮助用户更好地融入社区并参与内容讨论与分享。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20community%20network%20visualization%20with%20connected%20circles%20and%20flowing%20lines%2C%20warm%20coral%20and%20gold%20accents%2C%20cream%20background%2C%20minimalist%20soft%20design%2C%20no%20text%20or%20labels&width=800&height=500&seq=card-05-51cg&orientation=landscape',
    tag: '社区指南',
  },
  {
    title: '内容更新追踪方法',
    desc: '掌握追踪51cg内容更新的实用技巧，了解平台更新节奏与重点关注方向，不错过任何重要内容变化。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20timeline%20and%20update%20tracking%20concept%20with%20flowing%20data%20points%2C%20warm%20amber%20and%20sage%20highlights%2C%20cream%20background%2C%20minimalist%20clean%20design%2C%20soft%20gradient%2C%20no%20text&width=800&height=500&seq=card-06-51cg&orientation=landscape',
    tag: '技巧分享',
  },
  {
    title: '多端访问体验对比',
    desc: '比较桌面端与移动端访问51cg的体验差异，根据您的使用场景和需求推荐最适合的访问方式。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20multi%20device%20synchronization%20concept%20with%20geometric%20shapes%2C%20warm%20coral%20and%20gold%20toned%20highlights%2C%20cream%20background%2C%20minimalist%20editorial%20style%2C%20no%20text%20or%20labels&width=800&height=500&seq=card-07-51cg&orientation=landscape',
    tag: '使用对比',
  },
];

export default function CardSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">图文卡片</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">精选51cg相关主题图文内容，帮助您全方位了解平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => (
            <article
              key={i}
              className={`group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[8/5]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}